export const LOGIN_API = '/auth/users/sign_in'
export const LOGOUT_API = '/auth/users/sign_out'
export const DOWNLOAD_FILE_API = '/attachments/download'
export const SIGN_OUT_API = '/api/auth/sign-out'
export const VERIFY_RECAPTCHA_API = '/api/verify-recaptcha'
export const GRAPHQL_API = '/graphql'
